import React from "react";
import { Modal, Button } from "react-bootstrap";
import { all_routes } from "../feature-module/router/all_routes";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useDispatch } from "react-redux";
import { sendUserInvite } from "../core/data/redux/manageUser/_manageUserAction";
import ResendInviteModalIcon from "../icons/ResendInviteModalIcon";

interface ResendInviteModalProps {
  show: boolean;
  onHide: () => void;
  data: any
}

const ResendInviteModal: React.FC<ResendInviteModalProps> = ({ show, onHide, data }) => {
  const routes: any = all_routes;
  const navigate = useNavigate();
  const dispatch: any = useDispatch();


  const handleConfirmLogout = async () => {
    try {
      if (!data) {
        toast.error("No user selected for resending invite");
        return;
      }

      const payload = {
        name: data?.name,
        email: data?.email,
        role: data?.role,
      };
      console.log('payload ======== ', payload);

      const result = await dispatch(sendUserInvite(payload));
      onHide();
    }
     catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.error);
      }
      console.log(error);
    }
  };


  return (
    <Modal
      className="deleteModal"
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="sm"
    >
      <Modal.Body className="text-center">
        <div className="mx-auto py-4">
          <ResendInviteModalIcon/>
        </div>
        <h4>Resend the invite?</h4>
        <p>Are you sure you want to resend the invite?</p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center gap-3">
        <Button className="btnWrp cancelBtn" onClick={onHide}>
          No
        </Button>
        <Button className="btnWrp" onClick={handleConfirmLogout}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResendInviteModal;